export default {"src":"/_next/static/media/heap-small.93ccd043.svg","height":48,"width":30,"blurWidth":0,"blurHeight":0};